<div class="form-group" [ngClass]="{
  'has-error': control?.invalid && (control?.dirty || control?.touched)
}">
  <input
    *ngIf="column.inputType === 'number' || column.inputType === 'percentage'"
    [id]="inputId"
    class="form-control"
    type="number"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
  />
  <input
    *ngIf="column.inputType === 'currency' "
    [id]="inputId"
    class="form-control"
    type="text"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
    appStringToNullValueAccessor
  />
  <input
    *ngIf="column.inputType === 'checkbox'"
    [id]="inputId"
    class="form-control"
    type="checkbox"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
  />

  <select
    *ngIf="column.inputType === 'select'"
    [id]="inputId"
    class="form-control"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
  >
    <option *ngFor="let option of column.options" [ngValue]="option.value">
      {{ option.label }}
    </option>
  </select>
  <div *ngIf="column.inputType === 'link' || column.inputType === 'none'"></div>
  <ng-container *ngIf="column.inputType === 'read-only'">
    <app-display-field
      [value]="control?.value"
      [column]="column"
    >
    </app-display-field>
    <input type="hidden" [formControlName]="controlName" />
  </ng-container>
  <app-checkbox-list
    *ngIf="column.inputType === 'checkbox-list' && column.options"
    [id]="inputId"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
    [options]="column.options"
  >
  </app-checkbox-list>
  <input
    *ngIf="column.inputType === 'new-password'"
    [id]="inputId"
    class="form-control"
    type="password"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
    autocomplete="new-password"
  />
  <input
    *ngIf="!['number','percentage', 'currency','checkbox', 'select', 'link', 'none','checkbox-list', 'new-password', 'read-only'].includes(column.inputType)"
    [id]="inputId"
    class="form-control"
    [type]="column.inputType || 'text'"
    [name]="controlName"
    [title]="column.label"
    [formControlName]="controlName"
  />
</div>

